module.exports = __webpack_public_path__ + "static/media/header-shapes.d0446439.svg";